import { SortBySelectOption } from '@/types';

export const SORT_BY_FIELD_OPTION: SortBySelectOption[] = [
  {
    label: 'Price Low to High',
    value: { field: 'price', order: 'asc' },
  },
  {
    label: 'Price High to Low',
    value: { field: 'price', order: 'desc' },
  },
  {
    label: 'THC High to Low',
    value: { field: 'totalThcPercent', order: 'desc' },
  },
  {
    label: 'THC Low to High',
    value: { field: 'totalThcPercent', order: 'asc' },
  },
  // {
  //   label: 'Type A to Z',
  //   value: { field: 'productTypeName', order: 'asc' },
  // },
  // {
  //   label: 'Type Z to A',
  //   value: { field: 'productTypeName', order: 'desc' },
  // },
  {
    label: 'Brand A to Z',
    value: { field: 'brand', order: 'asc' },
  },
  {
    label: 'Brand Z to A',
    value: { field: 'brand', order: 'desc' },
  },
  // {
  //   label: 'Subtype (Asc)',
  //   value: { field: 'subType', order: 'asc' },
  // },
  // {
  //   label: 'Subtype (Desc)',
  //   value: { field: 'subType', order: 'desc' },
  // },
  {
    label: 'Classification A to Z',
    value: { field: 'classification', order: 'asc' },
  },
  {
    label: 'Classification Z to A',
    value: { field: 'classification', order: 'desc' },
  },
  // {
  //   label: 'Generals (Asc)',
  //   value: { field: 'generals', order: 'asc' },
  // },
  // {
  //   label: 'Generals (Desc)',
  //   value: { field: 'generals', order: 'desc' },
  // },
  // {
  //   label: 'Effects (Asc)',
  //   value: { field: 'effects', order: 'asc' },
  // },
  // {
  //   label: 'Effects (Desc)',
  //   value: { field: 'effects', order: 'desc' },
  // },
  // {
  //   label: 'Flavors (Asc)',
  //   value: { field: 'flavors', order: 'asc' },
  // },
  // {
  //   label: 'Flavors (Desc)',
  //   value: { field: 'flavors', order: 'desc' },
  // },
];

export enum PRODUCT_FILTER_ATTRIBUTES {
  _ID = 'id',
  _CATEGORY = 'category.keyword',
  _BRAND = 'brand.keyword',
  _SUBTYPE = 'subtype',
  _CLASSIFICATION = 'classification',
  _GENERALS = 'generals',
  _EFFECTS = 'effects',
  _FLAVORS = 'flavors',
  _TOTAL_THC_PERCENT = 'customTHCPercentageMinValue',
  _PRICE = 'customMinPrice',
  _SIZE = 'customSize',
  _ON_SALE = 'onSale',
  _IS_HIDE_FROM_MENU = 'isHideFromMenu',
  _IS_ABOVE_THRESHOLD = 'isAboveThreshold',
  _SORT = 'sort',
  _PAGE = 'page',
  _QUERY = 'query',
}

const ProductFilters = [
  {
    attribute: PRODUCT_FILTER_ATTRIBUTES._ID,
    type: 'refinement',
  },
  {
    attribute: PRODUCT_FILTER_ATTRIBUTES._CATEGORY,
    type: 'refinement',
  },
  {
    attribute: PRODUCT_FILTER_ATTRIBUTES._BRAND,
    type: 'refinement',
  },
  {
    attribute: PRODUCT_FILTER_ATTRIBUTES._SUBTYPE,
    type: 'refinement',
  },
  {
    attribute: PRODUCT_FILTER_ATTRIBUTES._CLASSIFICATION,
    type: 'refinement',
  },
  {
    attribute: PRODUCT_FILTER_ATTRIBUTES._GENERALS,
    type: 'refinement',
  },
  {
    attribute: PRODUCT_FILTER_ATTRIBUTES._EFFECTS,
    type: 'refinement',
  },
  {
    attribute: PRODUCT_FILTER_ATTRIBUTES._FLAVORS,
    type: 'refinement',
  },
  {
    attribute: PRODUCT_FILTER_ATTRIBUTES._TOTAL_THC_PERCENT,
    type: 'numeric',
  },
  {
    attribute: PRODUCT_FILTER_ATTRIBUTES._PRICE,
    type: 'numeric',
  },
  {
    attribute: PRODUCT_FILTER_ATTRIBUTES._SIZE,
    type: 'refinement',
  },
  {
    attribute: PRODUCT_FILTER_ATTRIBUTES._ON_SALE,
    type: 'refinement',
  },
];

export const InitialProductQueryFilters: Record<string, string[]> =
  ProductFilters.filter(
    ({ attribute }) => attribute !== PRODUCT_FILTER_ATTRIBUTES._ON_SALE,
  ).reduce(
    (acc, { attribute, type }) => ({
      ...acc,
      [attribute]: type === 'refinement' ? ([] as string[]) : [':'],
    }),
    {},
  );

export const FilterAttributeNameMapping: Record<string, string> = {
  brand: PRODUCT_FILTER_ATTRIBUTES._BRAND,
  price: PRODUCT_FILTER_ATTRIBUTES._PRICE,
  totalTHCPercent: PRODUCT_FILTER_ATTRIBUTES._TOTAL_THC_PERCENT,
};

export const STRAIN_ORDER = ['Hybrid', 'Indica', 'Sativa', 'CBD', 'I/S', 'S/I'];
